import {IRouteStore} from '../../router/routing.infra';
import {getRootStore} from '../../app.bootstrap';
import {WifiAnalyzerHistoryController, IWifiAnalyzerHistoryController} from './controller';

export type SearchCriteria = {
    startDate?: string;
    endDate?: string;
    customerRef?: string;
    roomId?: string;
    preDataCollectionCode?: string;
    scanId?: string;
    customerNumber?: string;
    customerEmail?: string;
};

export interface IWifiAnalyzerHistoryStore extends IRouteStore {
    wifiAnalyzerHistoryController: IWifiAnalyzerHistoryController;
    localizationService: any;
    dispose(): void;
}

export class WifiAnalyzerHistoryStore implements IWifiAnalyzerHistoryStore {
    public wifiAnalyzerHistoryController: IWifiAnalyzerHistoryController;
    public localizationService: any;

    constructor(
        accountData: {
            _id: string;
            protectedSettings?: {
                reportsDateFormat?: string;
            };
            settings?: {timezone?: string; language?: string};
        },
        searchCriteria: SearchCriteria,
        isEmbedded: boolean
    ) {
        const rootStore = getRootStore();

        this.localizationService = rootStore.localizationService;

        const translate = rootStore.localizationService.translate.bind(rootStore.localizationService);

        const goToDashboardPage = async (roomId: string, scanId: string) => {
            await rootStore.tsSessionData.setValue('roomId', roomId);
            const query = `?offline=true&history=true&roomId=${encodeURIComponent(roomId)}&scanId=${encodeURIComponent(scanId)}`;
            rootStore.browserUtilsService.redirect(`/dashboard/main${query}`);
        };

        const goToInvitePage = isEmbedded
            ? undefined
            : () => {
                  rootStore.redirectionService.goToInvite();
              };

        this.wifiAnalyzerHistoryController = new WifiAnalyzerHistoryController(
            translate,
            accountData._id,
            accountData.protectedSettings?.reportsDateFormat ?? '',
            accountData.settings?.timezone ?? '',
            accountData.settings?.language ?? 'en_US',
            searchCriteria,
            goToDashboardPage,
            goToInvitePage
        );

        this.wifiAnalyzerHistoryController.searchHistory();
    }

    dispose(): void {
        // Cleanup if needed
    }
}
